import { domStorage, viewStorage } from '../_globals'
import gsap from 'gsap'

export default class ConfigPopupProduct {
  constructor() {
    if (!domStorage.configPopupProduct) return

    this.DOM = {
      allButtons: domStorage.body.querySelectorAll('.Btn'),

      inner: domStorage.configPopupProduct.querySelector('.ConfigPopup__inner'),
      input: domStorage.configPopupProduct.querySelector('input'),
      closeButton: domStorage.configPopupProduct.querySelector('.ConfigPopup__inner__close')
    }

    this.parameterURL = '#fiche-technique'

    this.setEvents()
  }

  setEvents() {
    this.open = this.open.bind(this)
    this.close = this.close.bind(this)

    if (this.DOM.allButtons.length) {
      this.DOM.allButtons.forEach(button => {
        const href = button.getAttribute('href')
        
        if (href && href.includes(this.parameterURL)) {
          button.setAttribute('data-taxi-ignore', 'true')
          button.addEventListener('click', this.open)
        }
      })
    }

    this.DOM.closeButton.addEventListener('click', this.close)
  }

  open(event) {
    event.preventDefault()

    this.timelineIn = gsap.timeline({
      default: {
        ease: 'expo.out',
        duration: 0.75
      },
      onStart: () => {
        document.body.style.overflow = 'hidden'
        domStorage.configPopupProduct.style.pointerEvents = 'all'

        if (viewStorage.viewScroll.scroll) {
          viewStorage.viewScroll.scroll.stop()
        }
      },
      onComplete: () => {
        this.DOM.input.focus()
      }
    })

    this.timelineIn.fromTo(domStorage.configPopupProduct, {
      opacity: 0
    }, {
      opacity: 1,
    }, 0)

    this.timelineIn.fromTo(this.DOM.inner, {
      yPercent: 100,
      scale: 0.4,
      rotate: gsap.utils.random(-12, 12),
      opacity: 0
    }, {
      yPercent: 0,
      scale: 1,
      rotate: 0,
      opacity: 1,
      ease: "elastic.out(1,0.95)",
      duration: 1
    }, 0.5)

    return this.timelineIn
  }

  close(event) {
    event.preventDefault()

    this.timelineOut = gsap.timeline({
      defaults: {
        ease: 'expo.out',
        duration: 0.75
      },
      onStart: () => {
        domStorage.configPopupProduct.style.pointerEvents = ''
        this.DOM.input.blur()
      },
      onComplete: () => {
        if (viewStorage.viewScroll.scroll) {
          viewStorage.viewScroll.scroll.start()
        }

        document.body.style.overflow = ''
      }
    })

    this.timelineOut.to(domStorage.configPopupProduct, {
      opacity: 0,
    }, 0)

    return this.timelineOut
  }

  destroy() {
    if (this.timelineIn) {
      this.timelineIn.kill()
      this.timelineIn = null
    }
    
    if (this.timelineOut) {
      this.timelineOut.kill()
      this.timelineOut = null
    }

    // Remove event listeners
    if (this.DOM.allButtons.length) {
      this.DOM.allButtons.forEach(button => {
        const href = button.getAttribute('href')
        if (href && href.includes(this.parameterURL)) {
          button.removeEventListener('click', this.open)
        }
      })
    }

    if (this.DOM.closeButton) {
      this.DOM.closeButton.removeEventListener('click', this.close)
    }

    // Reset DOM references
    this.DOM = null
  }
}
